export function comparefields(a, b) {
  var ac = a.GetCalcCode() != null || a.FieldReadOnly();
  var bc = b.GetCalcCode() != null || b.FieldReadOnly();

  if (ac == bc) {
    var an = a.GetFieldDisplayName().toLowerCase();
    var bn = b.GetFieldDisplayName().toLowerCase();
    if (an < bn) return -1;
    if (an > bn) return 1;
    return 0;
  } else {
    if (bc) return -1;
    else return 1;
  }
}
